export const FETCH_REQUEST = "FETCH_REQUEST";
export const FETCH_SUCCESS = "FETCH_SUCCESS";
export const FETCH_FAILURE = "FETCH_FAILURE";
export const CLEAR_ALL = "CLEAR_ALL";

export type FetchKey = string; // e.g. "/projects/123/climate/18"

export const fetchRequest = (key: FetchKey) => ({
  type: FETCH_REQUEST,
  payload: { key },
});

export const fetchSuccess = (key: FetchKey, data: any) => ({
  type: FETCH_SUCCESS,
  payload: { key, data },
});

export const fetchFailure = (key: FetchKey, error: any) => ({
  type: FETCH_FAILURE,
  payload: { key, error },
});

export const clearAll = () => ({ type: CLEAR_ALL });

const actions = {
  fetchRequest,
  fetchSuccess,
  fetchFailure,
  clearAll,
};

export default actions;
